<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <g transform="translate(-292 -130)">
     <path d="M309.219,145.572h-0.867l-0.308-0.3c2.57-2.994,2.226-7.504-0.768-10.074c-2.994-2.57-7.504-2.226-10.074,0.768
      s-2.226,7.504,0.768,10.074c2.677,2.297,6.629,2.297,9.306,0l0.3,0.308v0.867l3.293,3.281l1.635-1.635L309.219,145.572z
       M302.634,145.572c-2.727,0-4.938-2.211-4.938-4.938s2.211-4.938,4.938-4.938c2.727,0,4.938,2.211,4.938,4.938c0,0,0,0,0,0
      c0.003,2.724-2.202,4.935-4.926,4.938C302.642,145.572,302.638,145.572,302.634,145.572z"/>
    </g>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'search'
}
</script>
